module.exports = __webpack_public_path__ + "media/assets/images/flags/gr-a7290660b812f67fcc0d6a688bcf819e.svg";